import { Footer } from "../../components/ComponentZapMei/Footer";
import { HomeComponentZapMei } from "../../components/ComponentZapMei/Home";

function ZapMei() {


  return (
    <>
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TS8B3D9S"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <HomeComponentZapMei />

      <div style={{ background: "#091a27", width: "100%" }}>
        <Footer />
      </div>
    </>
  );
}
export default ZapMei;
